// components
import React from 'react';
import { INewsletter } from '../../models/Newsletters/INewsletter';
import NewsletterCard from './components/NewsletterCard';
import { getNewsletters } from './helper';
import styles from './NewslettersPage.module.css';
import { env  } from '../../env';

const NewslettersPage = () => {
  const newsletters: INewsletter[] = getNewsletters();
  return (
    <React.Fragment>
      <div className={styles.container}>
        <div className={styles.newsLetterTitle}>Newsletters</div>
        <div className={styles.newsLetterTitleDesc}><b>Explore SHRM Flagships, each featuring podcast, video and newsletter. Listen, watch, and read as the future unfolds.</b></div>
        {newsletters.map((newsletter, index) => {
          return (
            <NewsletterCard
              key={index}
              imageUrl={newsletter.imageUrl}
              title={newsletter.title}
              description={newsletter.description}
              buttonUrl={newsletter.buttonUrl}
            />
          );
        })}
        <div>
          <div className={styles.exploreAllBoldContent}>Stay up-to-date on HR topics that matter most to you with our other newsletters.</div>
          <a href={env.REACT_APP_NEWSLETTER} target='_blank'><div className={styles.exploreAllButton}>EXPLORE ALL NEWSLETTERS</div></a>
          <div className={styles.exploreAllLightContent}>Update your communication preferences at any time by clicking the link at the bottom of any SHRM email.</div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NewslettersPage;
